import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import { rem } from 'polished';
import { Box, Heading, Link, Text, Flex } from '@qga/roo-ui/components';

const InlineLink = styled(Link)`
  display: inline;
  overflow-wrap: break-word;
`;

// Browser print styles
export const PageContainer = styled(Box)`
  color: #323232;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 20px;
`;

export const PrintViewPageContainer = styled(Box)`
  margin: 8px;
`;

export const SectionContainer = styled(Box)``;

export const Container = styled(Box)`
  margin: 0 auto;
  max-width: ${themeGet('breakpoints.1')};
`;

export const Row = styled(Flex)``;

export const Column = styled(Box)`
  padding: 0 6px;
  flex-basis: 0;
  flex-grow: 1;

  &:first-of-type {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`;

export const SmallSizeText = ({ children }) => (
  <Text fontSize="xs" as="p" lineHeight="16px" m={0}>
    {children}
  </Text>
);

export const SmallContent = styled(Box)`
  color: #666;
  font-size: 13px;
`;

export const TextP = ({ children, ...styles }) => (
  <Text as="p" my={2} lineHeight={rem(20)} {...styles}>
    {children}
  </Text>
);

export const RedLink = ({ label, url }) => (
  <InlineLink href={url} target="_blank">
    {label} ({url})
  </InlineLink>
);

export const H1 = styled(Heading.h1)`
  font-size: 19px;
  line-height: 28px;
  margin: 4px 0;
  font-weight: bold;
`;

export const H2 = styled(Heading.h2)`
  font-size: 16px;
  line-height: 24px;
  margin: 4px 0;
  font-weight: bold;
`;

export const H3 = styled(Heading.h3)`
  font-size: 14px;
  margin: 4px 0;
  font-weight: bold;
`;

export const Spacer = styled(Box)`
  height: 12px;
`;
